<!-- UniInput Component Builder -->

<template>
	<div class="bld-uniinput">
		<div class="title wi8_font">Uni Input Builder</div>

		<button @click="setColName('name')">Name</button> &nbsp;
		<button @click="setColName('email')">Email</button> &nbsp;
		<button @click="setColName('story')">Story</button>  &nbsp;
		<button @click="goPop()">Popup</button> &nbsp;

		<div class="v-spacer"></div>

		<div class="my-text" v-html="convertLFs(rec[colName])" />

		<div class="v-spacer"></div>
		<div class="v-spacer"></div>

		Content<br/>
		<div class="content">
			<UniInput 
				v-if="showComp"
				:compData="compData"
			/>
		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils.js";
import CfgApp from "@/assets/cfg/CfgApp";
import * as Utils from "@/utils/utils";
import { eventBus } from "@/main";
export default {
	data() {
		return {
			rec: {
				name: "Maxwell",
				email: "msmart@chaos.com",
				story: "My story is a sad, but not uncommon, tale of broken promises.\nIt began long ago in the Seychelles.\nLine 3\nLine 4",
			},
			showComp: true,
			colName: "xxx",
			compData: {},
			popData: {
				name: {
					popType: "win",
					compName: "UniInput",
					popTitle: "What is My Name?",
					compData: {
						colName: "name",
						defaultVal: "",
						maxLen: 20,
					},
				},
				email: {
					popType: "win",
					compName: "UniInput",
					popTitle: "Return Email Address",
					compData: {
						colName: "email",
						defaultVal: "",
						maxLen: 50,
					},
				},
				story: {
					popType: "win",
					compName: "UniInput",
					popTitle: "Please Enter your Story",
					compData: {
						colName: "story",
						defaultVal: "",
						maxLen: 150,
						multiLine: true,
					},
				}
			}
		}
	},
	methods: {
		setColName(colName) {
			m("bld uninput: set col name", colName);
			this.colName = colName;
			this.compData = this.popData[colName].compData;
			this.compData.defaultVal = this.rec[this.colName];
		},

		goPop(val) {
			m("bld uninput: go pop", this.colName);

			let data = this.popData[this.colName];
			data.compData.defaultVal = this.rec[this.colName];
			m("data", data);
			eventBus.$emit("popup", data);			
			this.showComp = false;
		},
		handleUpdateVal(payload) {
			m("bld uninput: handle update", payload);
			let colName = payload.colName;
			let val = payload.val;

			// Check CfgApp.toggleRole keys
			if (val==CfgApp.toggleRole.hotWord) {
				val = "";
				eventBus.$emit("togglerole");
			}

			m(colName + " new val", val.length, val);

			// el.innerText = val;
			this.rec[colName] = val;
			this.compData.defaultVal = val;			
			m("rec is now", this.rec);
		},
		convertLFs(str1="") {
			let str2 = str1.replace(/\n/g, '<br/>', );
			m("bld uninput: convert LFs:", str1, str1.length, str2, str2.length);
			return str2;
		},
		handlePopoff() {
			m("bld uninput: handle popoff")
			this.showComp = true;
			// Utils.blur();
		},
	},
	created() {
		m("bld uninput: created");
		this.setColName("story");
		eventBus.$emit('popoffall'); // Close all modal windows
		eventBus.$on('update-value', this.handleUpdateVal);
		eventBus.$on('popoff', this.handlePopoff);
	},
	beforeDestroy() {
		m("bld uninput: bef destroy");
		eventBus.$off('update-value', this.handleUpdateVal);
		eventBus.$off('popoff', this.handlePopoff);
	},
}
</script>

<style scoped>
.bld-uniinput {
	height: 100%;
	overflow: hidden;
	padding: 5px;
	background-color: #FCFCEE;
	border: solid 0px #C30;
}



.title {
	height: 30px;
	color: #690;
	border: solid 0px #369;
}

.my-text {
	height: 80px;
	overflow: auto;
	border: solid 1px #999;
}

.content {
	height: calc(100% - 200px);
	overflow: hidden;
	border: solid 1px #369;
}

.v-spacer {
	width: 10px;
	height: 10px;
	overflow: hidden;
	border: solid 0px #C30;
}


button {
	width: 80px;
}

.pop-value-box {
	display: inline-block;
	width: 190px;
	height: 25px;
	overflow: hidden;
	vertical-align: top;
	cursor: pointer;
	background-color: #FFF;
	border: solid 1px #999;
}

</style>
